import { render, staticRenderFns } from "./formIdentitas.vue?vue&type=template&id=2232fd72&"
import script from "./formIdentitas.vue?vue&type=script&lang=js&"
export * from "./formIdentitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports